import React, { isValidElement } from 'react'
import { NumericFormat as NumberFormat } from 'react-number-format';
import { customer_order_form_norate } from './configs/pdf_configs';
import apiConfig from './config/api';


const CreateDetailHTML = async (state,from, to) => {
    const {has_voltageoptimser, has_iboost, has_smart_thermostat, currency, savings,
        total_system_cost, total_benefit, total_profit, average_monthly_net_contribution,tot_energy_cost,
        tot_solar_and_battery_capped_money,
        tot_smart_export_money,
        tot_vo_money_savings,
        tot_iboost_savings_money,
        tot_smartthermostat_savings_money,
        tot_se_savings,
        tot_capped_accumulative_savings,
        tot_annual_loan_cost,
        tot_annual_loan_after_savings,
        tot_monthly_loan_after_savings, totals } = state

    const has_smart_energy = false // Reset later if needed!!
    
    let has_finance = typeof state.financeoption !== "undefined" ? true : false
    try {
        if((state.financeoption.uid??0) == 0)
            has_finance = false
    }catch(e) { has_finance = false }
    //console.log(`has_finance = ${has_finance}`)
    //console.log(state.financeoption)
    //console.log("CreateDetailHTML from  " + from + " to " + to )
    //console.log(savings )
    //console.log(totals)
    
    function nf(val,num) {
        var n = parseFloat(val)
        if(!isNaN(n))
            n = roundOff(n,num)
        if(!isNaN(n))
            return n.toFixed(num)
        else {
            n = 0
            return n.toFixed(num)
        }
    }

    function roundOff(value,round) {
        return (parseInt(value * (10 ** (round + 1))) - parseInt(value * (10 ** round)) * 10) > 4 ? (((parseFloat(parseInt((value + parseFloat(1 / (10 ** round))) * (10 ** round))))) / (10 ** round)) : (parseFloat(parseInt(value * (10 ** round))) / ( 10 ** round));
     }
    var monthly_savings = (totals.tot_capped_accumulative_savings/savings.length/12)??0.00
    var monthly_loan = 'N/A'
    if(has_finance) monthly_loan = nf(savings[0].annual_loan_cost/12,2)

    let tot_roi = 0
    for(let i=0; i<savings.length; i++)
          tot_roi+=savings[i].annual_roi 
    let avg_annual_roi = tot_roi / savings.length

    var strHtml=`<html><head><link rel="stylesheet" href="${apiConfig.baseUrl}/api/templates/css/datasheets.css"></head><body>`
    strHtml += "<div class='table2'> <div class='table_container' >"
    strHtml += "<span class='style30years' >Your " + state.calcterm + " Year Projected Earnings &amp; Savings</span>"
    strHtml += "<table class='tbl1_class' >"
    strHtml += "<tr>"
    strHtml += "<thead>"
    strHtml += "<th class='yrheadersaving' colspan=3>"
    strHtml += "<span class='tbl1_top_prices'>&pound;" + total_benefit + "</span><br/>"
    strHtml += "<span class='tbl1_bottom_price' >Total Benefit*</span></th>"
    strHtml += "<th >&nbsp;</th>"
    strHtml += "<th class='yrheadersaving'  colspan=4>"
    strHtml += "<span class='tbl1_top_prices' >&pound;" + total_profit + "</span><br/>"
    strHtml += "<span class='tbl1_bottom_price' >Total Profit (tax free)</span></th>"
    strHtml += "<th >&nbsp;</th>"
    strHtml += "<th class='yrheadersavingbb'  colspan=3 ><div style='width: 80%; text-align: right;'>"
    strHtml += "<span class='tbl_bottom16_price'>Average Monthly Loan Payment</span><span class='tbl1_top_prices'>&nbsp;&nbsp;&pound;" + monthly_loan + "</span><br/>"
    strHtml += "<span class='tbl_bottom16_price'>Average Monthly Savings</span><span class='tbl1_top_prices'>&nbsp;&nbsp;&pound;" + monthly_savings.toFixed(2) + "</span></div>"
    //strHtml += "<span class='tbl_bottom16_price'>Contribution (over loan term)</span></th>"
    strHtml += "</tr>"
    strHtml += "</thead>"
    strHtml += "</table><br/>"
    strHtml += "<table class='tbl2_class'>"
    strHtml += "<thead>"
    strHtml += "<tr>"
    strHtml += "<th class='savingsHeaders'>Year</th>"
    strHtml += "<th class='savingsHeaders' >Energy Cost</th>"
    strHtml += "<th class='savingsHeaders'>Battery &amp; Solar<br/>Savings</th>"
    strHtml += "<th class='savingsHeaders'>SMART Export<br/>Benefit</th>"
    if(has_voltageoptimser)
        strHtml += "<th class='savingsHeaders' >Voltage<br/>Optimiser</th>"
    if(has_iboost)  
        strHtml += "<th class='savingsHeaders' >iBOOST</th>"
    if(has_smart_thermostat)
        strHtml += "<th class='savingsHeaders' >SMART<br/>Thermostat</th>"
    if(has_smart_energy) 
        strHtml += "<th class='savingsHeaders' >**SMART Energy<br/>Tariff Benefit</th>"
    strHtml += "<th class='savingsHeaders' >Accumulative<br/>Savings</th>"
    strHtml += "<th class='savingsHeaders' >Bill Savings<br/>%</th>"
    if(has_finance) 
        strHtml += "<th class='savingsHeaders'>Annual Loan<br/>Cost</th>"
    if(has_finance) 
        strHtml += "<th class='savingsHeaders' >Monthly<br/>Loan Cost</th>"
    strHtml += "<th class='savingsHeaders' >Average Monthly<br/>Savings</th>"
    strHtml += "<th class='savingsHeaders' >Your Average<br/>Annual ROI%</th>"         
    strHtml += "</tr>"
    strHtml += "</thead>"
    strHtml += "<tbody>"
    var strOut =""
    const iFrom = from
    const iTo = to
    //console.log("Filter")
    //console.log(savings.filter(item => item.year >= iFrom && item.year <= iTo ))
    //console.log("has_finance " + has_finance)
    if(1==1 || has_finance) {
        var dataset = savings.filter(item => item.year >= iFrom && item.year <= iTo )

        strOut += dataset.map((item) => { 
            var rowcls = "text30Red"   
            const stdRowCls = "text30"    
            const stdRowCls2 = "text30b"  
            if(item.payback )
                    rowcls="text30Grn"
            if(item.display_loan_details == "N")
                rowcls="text30Grn"
        
            var strH ="<tr key='" + item.year + "'  selected='" + item.breakeven + "'  class='" + stdRowCls + "' >"
            strH +="<td class='" + stdRowCls + "' ><div class='numssml'>" + item.year + "</div></td>"
            strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.energy_cost,2) + "</div></td>"
            strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.solar_and_battery_capped_money,2) + "</div></td>"
            strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.capped_smart_export_money,2) + "</div></td>"
            if(has_voltageoptimser) strH+= "<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.vo_money_savings,2) + "</div></td>"
            if(has_iboost) strH+="<td class='" + rowcls + "' ><div class='nums'>&pound; " + nf(item.iboost_savings_money,2) + "</div></td>"
            if(has_smart_thermostat) strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.smartthermostat_savings_money,2) + "</div></td>"
            if(has_smart_energy) strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + nf(item.se_savings,2) + "</div></td>"
            strH +="<td class='" + rowcls + "' ><div class='nums'>&pound;" + nf(item.capped_accumulative_savings,2) + "</div></td>"
            strH +="<td class='" + stdRowCls + "' ><div class='nums'>" + nf(item.capped_accumulative_savings_percent,1) + "%</div></td>"
            if(has_finance) strH +="<td class='" + stdRowCls + "' ><div class='nums'>&pound; " + (item.annual_loan_cost >0 ? nf(item.annual_loan_cost,2) : '0.00') + "</div></td>"
            if(has_finance) strH +="<td class='" + stdRowCls + "' ><div class='numsw'>&pound; " + (item.annual_loan_cost >0 ? nf(item.annual_loan_cost/12,2) : '0.00')  + "</div></td>"
            strH +="<td class='" + rowcls + "' ><div class='nums'>&pound; " + nf(item.capped_accumulative_savings/12,2) + "</div></td>"
            strH +="<td class='" + stdRowCls2 + "' ><div class='nums'>" + nf(item.annual_roi,1) + "%</div></td>"
            strH +="</tr>"
            return(strH)
        })
    }
    strHtml += strOut.replaceAll("</tr>,","</tr>")
    strHtml +="<tr class='text30' >"
    strHtml +="<td class='text30b' >Totals</td>"
    strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_energy_cost,2) + "</div></td>"
    strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_solar_and_battery_capped_money,2) + "</div></td>"
    strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_smart_export_money,2) + "</div></td>"
    if(has_voltageoptimser) strHtml+= "<td class='text30' ><div class='numsb'>&pound; " + nf(totals.tot_vo_money_savings,2) + "</div></td>"
    if(has_iboost) strHtml+="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_iboost_savings_money,2) + "</div></td>"
    if(has_smart_thermostat) strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_smartthermostat_savings_money,2) + "</div></td>"
    if(has_smart_energy) strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(totals.tot_se_savings,2) + "</div></td>"
    strHtml +="<td class='text30b' ><div class='numsb'>&pound;" + nf(totals.tot_capped_accumulative_savings,2) + "</div></td>"
    strHtml +="<td class='text30b' ><div class='numsb'>" + nf(totals.perc_capped_saved,1) + "%</div></td>"
    if(has_finance) strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + ( totals.tot_annual_loan_cost >0 ? nf(totals.tot_annual_loan_cost,2) : '0.00') + "</div></td>"
    if(has_finance) strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(savings[0].annual_loan_cost/12,2)  + "</div></td>"
    strHtml +="<td class='text30b' ><div class='numsb'>&pound; " + nf(monthly_savings,2) + "</div></td>"
    strHtml +="<td class='text30' ><div class='numsb'>" + nf(avg_annual_roi,1) + "%</div></td>"
    strHtml +="</tr>"

    strHtml += "</tbody>"
    strHtml += "</table><br/>"
    strHtml += "<div id='footer' >"
    strHtml += "<div class='smallprint'>**Savings shown with Octopus Agile represent an average with figures taken from octopus.energy/agile/ and therefore cannot be validated by EPVS as usage/buying/selling variables change constantly in every home. Therefore Octopus savings cannot be included in the contract figures.</div><br/>"
    strHtml += "<div class='smallprint'>* The above annual validated saving figures represent what the solar + battery with any extras can save as a minimum - if your bill is less than the Validated savings shown, EPVS may require us to reduce the figures shown on the spreadsheet to match what you currently spend although the system will produce far greater savings as shown if/when your bill increases.</div><br/>"
    strHtml += "</div></div></div></body></html>"
    return(strHtml)
}


export default CreateDetailHTML